/**
 * @generated SignedSource<<db7883db345a246c9737a5dbd80fe491>>
 * @relayHash ac56ae6d536a6f2fe1427832ac8900e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df78232dcc3f8372ed0df16954229e956b6fcd9233d98bd251c8f2c15195fbd3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiSupportWebsiteOverviewServiceHubPageQuery } from './uiSupportWebsiteOverviewServiceHubPageQuery.graphql';

const node: PreloadableConcreteRequest<uiSupportWebsiteOverviewServiceHubPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "df78232dcc3f8372ed0df16954229e956b6fcd9233d98bd251c8f2c15195fbd3",
    "metadata": {},
    "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
